import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate, toUtc } from "@/lib/mood";
import { NoteThread } from "@/components/NoteThread";
import { logError } from "@/lib/log";

export const SupporterSentNotes = ({ token, name }) => {
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    api.get(`/supporters/view/${token}/notes`).then((r) => {
      setNotes(r.data);
      const hash = window.location.hash.slice(1);
      if (hash) setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "center" }), 100);
    }).catch((e) => logError("Sent notes failed:", e));
  }, [token]);

  if (!notes.length) return null;
  return (
    <div className="mm-card p-6" data-testid="supporter-sent-notes">
      <h2 className="font-semibold mb-3">Your conversations</h2>
      <div className="space-y-2">
        {notes.map((n) => (
          <div key={n.id} id={`note-${n.id}`} className="border rounded-2xl p-3 scroll-mt-24" data-testid={`supporter-sent-note-${n.id}`}>
            <div className="flex items-start gap-3">
              <p className="text-sm break-words flex-1 min-w-0"><span className="text-xs text-mm-muted block">Your note</span>{n.message}</p>
              <span className="text-xs text-mm-muted whitespace-nowrap flex items-center gap-1" data-testid={`supporter-sent-note-status-${n.id}`}>
                {n.hearted ? <><Heart size={13} className="fill-current text-mm-error" />Loved</> : fmtDate(toUtc(n.created_at), { month: "short", day: "numeric" })}
              </span>
            </div>
            <NoteThread note={n} me="supporter" otherName={name} endpoint={`/supporters/view/${token}/notes/${n.id}/reply`}
              onUpdate={(id, thread) => setNotes((list) => list.map((x) => (x.id === id ? { ...x, thread } : x)))} />
          </div>
        ))}
      </div>
    </div>
  );
};
